'use strict';

/* globals define, config, $, socket, app */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/account/mobile-settings', [], function () {
	var settings = {};

	settings.init = function () {
		settings.onNotificationOptionChanged();
		settings.getDeviceToken();
	};

	settings.onNotificationOptionChanged = function () {
		$('.notification-setting').on('change', function () {
			var el = $(this);

			socket.emit('plugins.mobileSettings.changeNotificationSetting', { id: el.attr('id'), isChecked: el.is(':checked') }, function (err) {
				if (err) {
					return app.alertError(err.message);
				}

				app.alert({
					title: 'Updated Categories',
					message: 'Changed!',
					type: 'success',
					timeout: 2000,
				});
			});
		});
	};

	settings.getDeviceToken = function () {
		$('#setDeviceTokenBtn').on('click', function () {
			socket.emit('plugins.mobileSettings.getDeviceToken', { }, function (err) {
				if (err) {
					return app.alertError(err.message);
				}
			});
		});
	};

	return settings;
});
